import { render, staticRenderFns } from "./ItemSearchCategorySelector.vue?vue&type=template&id=4c3560a4&scoped=true&"
import script from "./ItemSearchCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./ItemSearchCategorySelector.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSearchCategorySelector.vue?vue&type=style&index=0&id=4c3560a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3560a4",
  null
  
)

export default component.exports